type IProps = {
  spacing: string;
};

export const CustomComponentVerticalSpacer = ({ spacing }: IProps) => {
  return <div className={`h-0.5 w-full ${spacing}`} />;
};
